import {makeStyles} from "@material-ui/core"

export default makeStyles({
    /**
     * Carries the SCALED size of the figure, so the enclosing `.stage` gets a
     * scrollable area that matches what the reviewer can see. `.plot` below is
     * transformed, and a transform contributes nothing to layout — without this
     * box a zoomed-in 12-lead page would scroll as though it were still at
     * 100 % and its lower leads would be unreachable.
     *
     * The auto margins centre the figure while it is narrower than the stage;
     * once it is wider they resolve to zero, so nothing is pushed out of reach.
     */
    zoom_box: {
        position: "relative",
        flex: "none",
        marginLeft: "auto",
        marginRight: "auto",
    },
    /**
     * Shrink-wraps the Plotly figure so <ModernCaliperLayer/>, which stretches
     * to this box's edges, lands exactly on the axis area. The grid renders with
     * zero margins, so the figure's border box and its axis box are the same
     * rectangle — that is what lets the calipers derive millimetres per pixel
     * from a plain getBoundingClientRect().
     *
     * The zoom transform is applied HERE rather than to the box above so that
     * the calipers scale with the trace they are measuring. Origin `0 0` keeps
     * the scaled figure flush with the box, which is what makes the box's
     * width x zoom the correct scrollable size.
     */
    plot: {
        position: "relative",
        width: "max-content",
        // Plotly still emits its own inline width; this only stops the wrapper
        // from collapsing before the first draw.
        minWidth: 1,
        transformOrigin: "0 0",
    },
})
